import { MissionData } from '../blocks/mission'
import template from './templates/RJF02.rbxl'
import thumbnail0 from './thumbnails/RJF02/mission.png'
import thumbnail1 from './thumbnails/RJF02/BlueBlock.png'
import thumbnail2 from './thumbnails/RJF02/YellowBlock.png'
import thumbnail3 from './thumbnails/RJF02/RedBlock.png'
import thumbnail4 from './thumbnails/RJF02/WhiteBlock.png'

const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  template,
  thumbnail: thumbnail0,
  title: 'デッカイすべりだい！',
  chapters: [{}, {}, {}, {}, {}],
  objects: [
    {
      name: '①あおいブロック',
      thumbnail: thumbnail1,
    },
    {
      name: '②きいろいブロック',
      thumbnail: thumbnail2,
    },
    {
      name: '③あかいブロック',
      thumbnail: thumbnail3,
    },
    {
      name: '④しろいブロック',
      thumbnail: thumbnail4,
    },
  ],
}

export default mission
